import { render, staticRenderFns } from "./DayNightTabContent.vue?vue&type=template&id=35c678fc&scoped=true"
import script from "./DayNightTabContent.vue?vue&type=script&lang=js"
export * from "./DayNightTabContent.vue?vue&type=script&lang=js"
import style0 from "./DayNightTabContent.vue?vue&type=style&index=0&id=35c678fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c678fc",
  null
  
)

export default component.exports